export default function () {
  return {
    all: [],
    loading: false,
    saving: false,
    deleting: false,
    selected: false
  }
}
